import { unionBy } from 'lodash-es'

import { rootApi } from 'root-api'

const TAG_TYPES = ['ROUTING_FORMS', 'ROUTING_FORM']

const api = rootApi.enhanceEndpoints({ addTagTypes: TAG_TYPES }).injectEndpoints({
  endpoints: (build) => ({
    fetchRoutingForms: build.query({
      query: (
        {
          page = 1,
          filterTerm,
          start,
          end,
          period,
          ...params
        } = {}) => ({
        url: '/api/form_builder/analytics/forms',
        params: {
          pageNumber: page,
          filterTerm,
          start,
          end,
          period,
          ...params
        }
      }),
      serializeQueryArgs: ({ queryArgs }) => (
        queryArgs && { filterTerm: queryArgs.filterTerm }
      ),
      merge: (currentCache, newPage) => {
        currentCache.pagination = newPage.pagination
        if (newPage.pagination.currentPage > 1) {
          currentCache.collection = unionBy(currentCache.collection, newPage.collection, 'id')
        } else {
          currentCache.collection = newPage.collection
        }
      },
      forceRefetch({ currentArg, previousArg }) {
        return JSON.stringify(currentArg) !== JSON.stringify(previousArg)
      },
      providesTags: ['ROUTING_FORMS'],
      keepUnusedDataFor: 5
    }),
    fetchRoutingForm: build.query({
      query: (id) => ({
        url: `/api/form_builder/analytics/forms/${id}`
      }),
      providesTags: (_result, _error, { id }) => [{ type: 'ROUTING_FORM', id }],
      keepUnusedDataFor: 5
    }),
    fetchRoutingFormReport: build.query({
      query: ({
        organization,
        formId,
        start,
        end,
        range,
        ...params
      }) => ({
        url: '/api/reports/form_responses',
        params: {
          organization,
          formId,
          start,
          end,
          range,
          ...params
        }
      }),
      providesTags: ['ROUTING_FORM_REPORT'],
      keepUnusedDataFor: 0
    })
  })
})

export const {
  useFetchRoutingFormQuery,
  useFetchRoutingFormsQuery,
  useFetchRoutingFormReportQuery
} = api
